import type { Transition } from "@uirouter/core";

import { LEGACY_TO_V2_MAPPING } from "../routes/routes";
import { extractCategoriesFromRouteParams } from "../routes/routeUtils";

/**
 * Generic redirect function that handles legacy routes to comparison-enabled routes
 */
export const redirectLegacyToComparison = (transition: Transition) => {
    const toState = transition.to();
    const legacyRouteName = toState.name;

    const comparisonRouteName = LEGACY_TO_V2_MAPPING[legacyRouteName as keyof typeof LEGACY_TO_V2_MAPPING];
    if (!comparisonRouteName) {
        return;
    }

    const params = transition.params();

    const categoryArray = extractCategoriesFromRouteParams(params);

    const comparisonParams = {
        ...params,
        category: categoryArray,
        country: params.country as string,
        duration: params.duration as string,
        webSource: params.webSource as string,
        comparedDuration: params.comparedDuration as string,
        selectedMetric: params.selectedMetric as string,
        pageUrl: params.pageUrl as string,
    };

    return {
        state: comparisonRouteName,
        params: comparisonParams,
    };
};
